module.exports = __webpack_public_path__ + "img/product-thumb.ef154729.jpg";